








import { defineComponent } from '@vue/composition-api';

import getAllTags from '@/gql/getAllTags.gql';

import { useQuery, useResult } from '@vue/apollo-composable';

const TAG_GROUPS = {
  type: { name: 'Material' },
  content: { name: 'Content' },
  style: { name: 'Style' },
  design: { name: 'UI/UX Design' },
  nostalgia: { name: 'Nostalgia' },
  format: { name: 'ฟอร์แมตของไฟล์งาน' },
};

const PanelWithTagGroupDisplay = defineComponent({
  props: {
    onDark: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => ([]),
    },
  },
  setup() {
    const { result: getAllTagsResult } = useQuery(getAllTags);
    const tags = useResult(getAllTagsResult, [], (data: any) => data.tagGroups);

    function getTags(group: string) {
      return (tags.value.find((tagGroup: any) => tagGroup.slug === group) || { tags: [] }).tags;
    }

    return {
      tags,
      getTags,
      tagGroup: TAG_GROUPS,
      arrangement: Object.keys(TAG_GROUPS),
    };
  },
});

export default PanelWithTagGroupDisplay;
